import { BaseellaStatus } from '@ui/src';

export enum CurrencyTypeEnum {
  ALL = 'ALL',
  SPECIFIC = 'SPECIFIC',
}

export enum ProcessingTypeEnum {
  MINIMUM_AMOUNT_CHECK = 'MINIMUM_AMOUNT_CHECK',
  PSP_AUTO_SELECT = 'PSP_AUTO_SELECT',
}

export interface ProcessingRule {
  active: boolean;
  amount: number;
  createdAt: string;
  currencyId?: string;
  currencyType: CurrencyTypeEnum;
  deletedAt?: string;
  fromStatus: BaseellaStatus;
  id: string;
  processingType: ProcessingTypeEnum;
  pspIntegrationId?: string;
  pspIntegrationType: CurrencyTypeEnum;
  pspPartnerId?: string;
  pspPartnerType: CurrencyTypeEnum;
  toStatus: BaseellaStatus;
  typeId: string;
  updatedAt?: string;
  url?: string;
  currenciesIds?: string[];
  paymentCategoryId?: string;
  caspId?: string;
  pspPartnerAccountId?: string;
  pspPartnerAccountSelectType?: string;
  timeWindowType?: string;
  timeWindowStart?: string;
  timeWindowEnd?: string;
  render?: Record<string, React.JSX.Element>;
}

export interface PspPartner {
  companyName: string;
  id: string;
}

export interface PspIntegration {
  id: string;
  name: string;
}

export enum TimeScheduleEnum {
  SPECIFIC_TIME_WINDOW = 'SPECIFIC_TIME_WINDOW',
  FULL_DAY = 'FULL_DAY',
}

export enum PspParterAccountSelectTypeEnum {
  SPECIFIC = 'SPECIFIC',
  FROM_EXTERNAL_ACCOUNT = 'FROM_EXTERNAL_ACCOUNT',
}

export interface ProcessingRulesFormValues {
  active: string | boolean;
  typeId: string;
  fromStatus: string;
  toStatus: string;
  processingType: string;
  currencyType: string;
  currencyId?: string | null;
  amount?: string | number;
  pspIntegrationType: string;
  pspIntegrationId?: string | null;
  pspPartnerType: string;
  pspPartnerId?: string | null;
  paymentCategoryId?: string | null;
  caspId?: string | null;
  currenciesIds?: string[];
  timeWindowType?: string;
  timeWindowStart?: string | null;
  timeWindowEnd?: string | null;
  pspPartnerAccountSelectType?: string | null;
  pspPartnerAccountId?: string | null;
}

export interface PspAccount {
  id: string;
  description: string;
  pspPartnerId: string;
  pspPartner: PspPartner;
  account?: {
    clientName: string;
    id: string;
    fullNumber: string;
    description: string;
    overdraftEnabled: boolean;
  };
}
